import { createContext } from 'react';

import { noop } from '@/_shared';

import type { WidthStateProps } from './admin-state';

export const AdminContext = createContext<WidthStateProps>([{ isFullWidth: false, isDoubleColumn: false }, noop]);
